import { ExtraValidator } from '@nstep-common/utils';
import { EntitlementCheckModel } from '@nstep-public/pages';

export class EntitlementCheckModelValidator extends ExtraValidator<EntitlementCheckModel> {
	constructor() {
		super();

		this.ruleFor('amisCardNumber').matches(/^([A-Za-z]{3})(-[0-9]{7})(-[0-9]{2})$/);
	}
}